import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

function LiveTournaments() {
    const tournaments = useSelector((state) => state.tournaments) || [];
    return (
        <>
            <div className="container mx-auto px-4 max-w-6xl py-6">

                {/* Header */}
                <div className="flex items-center justify-between mb-4">

                    <div className="flex items-center gap-3">

                        {/* Icon */}
                        <div className="p-2 rounded-lg bg-gradient-to-br from-blue-500/20 to-purple-500/20 border border-blue-500/20">
                            📡
                        </div>

                        <h2 className="text-xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-purple-500">
                            Live Tournaments
                        </h2>

                    </div>

                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                    {tournaments.map((t, i) => (
                        <Link to={"/tournament/" + t.league_id} key={i}>
                            <div tabindex="0" style={{ opacity: 1, transform: 'none' }} >
                                <div class="rounded-lg border text-card-foreground shadow-sm cursor-pointer overflow-hidden border-border/50 bg-card/80 backdrop-blur hover:border-primary/50 transition-all group">
                                    <div class="p-4">
                                        <div class="flex items-center gap-3">
                                            <div class="w-12 h-12 rounded-lg p-1.5 border flex-shrink-0 border-border/30" style={{ backgroundColor: "rgb(209, 202, 201)" }}>
                                                <img src={t.league_logo} alt={t.league_name} class="w-full h-full object-contain" />
                                            </div>
                                            <div class="flex-1 min-w-0">
                                                <h3 class="font-semibold text-sm line-clamp-2 group-hover:text-primary transition-colors">{t.league_name}</h3>
                                                <div class="flex items-center gap-2 mt-1">
                                                    <span class="text-xs text-muted-foreground">⚽
                                                        {/* {t.type} */}
                                                        Football
                                                    </span>
                                                    {t.live && (
                                                        <div class="inline-flex items-center rounded-full border font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent bg-destructive/20 text-destructive animate-pulse text-[10px] px-1.5 py-0">
                                                            <span class="w-1.5 h-1.5 bg-current rounded-full mr-1 animate-pulse">
                                                            </span>
                                                            LIVE
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-right w-5 h-5 text-muted-foreground group-hover:text-primary transition-colors">
                                                <path d="m9 18 6-6-6-6">
                                                </path>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>
                {tournaments?.length === 0 &&
                    <>
                        <div className="flex flex-col items-center justify-center py-16 text-center border border-dashed border-gray-300 dark:border-gray-700 rounded-2xl">

                            <div className="text-6xl mb-4">
                                🏆
                            </div>

                            <h3 className="text-2xl font-bold text-gray-800 dark:text-white">
                                No Tournament Found
                            </h3>

                            <p className="text-gray-500 dark:text-gray-400 mt-2">
                                There are no live tournaments available right now.
                            </p>

                        </div>
                    </>
                }
            </div>
        </>
    );
}

export default LiveTournaments